import { render } from "./InventoryList.vue?vue&type=template&id=316fad72&scoped=true"
import script from "./InventoryList.vue?vue&type=script&lang=js"
export * from "./InventoryList.vue?vue&type=script&lang=js"

import "./InventoryList.vue?vue&type=style&index=0&id=316fad72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316fad72"]])

export default __exports__